module.exports = __webpack_public_path__ + "static/InfectedPersonsPrefecture_40.dot-2c455bcc438a7a5a611c0c7ff42a9c99.svg";